<template>
    <transition type="animation" appear enter-active-class="animate__animated animate__fadeIn" mode="out-in">
        <div v-if="temPermissao('segmento-infantil')" class="main">
            <b-container fluid="lg">
                <b-card no-body class="shadow-sm card_sistemacpv p-4">
                    <div @click="isToggleCadernoI" class="border border-light bg-light rounded-top p-3">
                        <div class="clearfix">
                            <div class="float-left">
                                <h5><strong>Infantil 3 (Maternal II)</strong> - Caderno 1</h5>
                            </div>
                            <div class="float-right">
                                <i class="fa-solid fa-minus" v-if="isCadernoICollapsed" style="color: #e98b24;"></i>
                                <i class="fa-solid fa-plus" v-else style="color: #e98b24;"></i>
                            </div>
                        </div>
                    </div>
                    <b-collapse v-model="isCadernoICollapsed" id="accordion-1"
                        class="border border-light rounded-bottom mb-3">
                        <div class="p-3 card_sistemacpv">
                            <b-row>
                                <b-col cols="12" md="4" lg="3" v-for="(list, index) in lists.data.caderno1" :key="index"
                                    class="">
                                    <b-card no-body class="mb-2" :img-src="list.src" img-alt="Image" img-top>
                                        <div v-if="list.videoId" style="height: 180px;">
                                            <youtube :video-id="list.videoId" player-width="100%" player-height="180px"
                                                onload="iFrameResize" />
                                        </div>
                                    </b-card>
                                </b-col>
                            </b-row>
                        </div>
                    </b-collapse>

                    <div @click="isToggleCadernoII" variant="transparent"
                        class="border border-light rounded-top bg-light p-3 mt-3">
                        <div class="clearfix">
                            <div class="float-left">
                                <h5><strong>Infantil 3 (Maternal II)</strong> - Caderno 2</h5>
                            </div>
                            <div class="float-right">
                                <i class="fa-solid fa-minus" v-if="isCadernoIICollapsed" style="color: #e98b24;"></i>
                                <i class="fa-solid fa-plus" v-else style="color: #e98b24;"></i>
                            </div>
                        </div>
                    </div>
                    <b-collapse v-model="isCadernoIICollapsed" id="accordion-1"
                        class="border border-light rounded-bottom">
                        <div class="p-3">
                            <b-row>
                                <b-col cols="12" md="4" lg="3" v-for="(list, index) in lists.data.caderno2"
                                    :key="index">
                                    <b-card no-body class="mb-3" :img-src="list.src" img-alt="Image" img-top>
                                        <div v-if="list.videoId" style="height: 180px;">
                                            <youtube :video-id="list.videoId" player-width="100%" player-height="180px"
                                                onload="iFrameResize" />
                                        </div>
                                        <!-- <div class="p-3">
                      <h6 class="text-center two-colors">{{ list.title }}</h6>
                      <hr />
                      <p v-if="list.isbn !== ''" class="text-center">{{ list.isbn }}</p>
                    </div> -->
                                    </b-card>
                                </b-col>
                            </b-row>

                        </div>
                    </b-collapse>

                    <b-row class="mt-4">
                        <b-col cols="12" v-for="(list, index) in lists.data.sugestao" :key="index">
                            <div class="d-flex justify-content-center">
                                <b-button href="http://www.letras.com.br/musicas-infantis" class="btn btn_sistemacpv"
                                    variant="transparent" target="_blank">
                                    <i class="fa-regular fa-music"></i>
                                    <span style="font-size: 14px">Confira outras sugestões.</span>
                                </b-button>
                            </div>
                        </b-col>
                    </b-row>
                </b-card>
            </b-container>
        </div>
        <div v-else>
            <div class="container">
                <div class="text-center">
                    {{ error503 }}
                    <p>Você não tem permissão para visualizar este conteúdo.</p>
                </div>

            </div>
        </div>
    </transition>
</template>

<script>

import {
    getIdFromURL,
    getTimeFromURL
} from 'vue-youtube-embed';
export default {

    data() {
        return {
            pageTitle: 'EDUCAÇÃO INFANTIL',
            pageSubtitle: 'INFANTIL 3 (MATERNAL II) - MÚSICAS',
            NamePermission: '',
            IndexPermission: '',

            lists: {
                data: {
                    caderno1: [{
                        linkReaOnly: 'https://www.youtube.com/watch?list=SRDona%20aranha&v=MuBgIfBR1kA',
                        LinkFree: '',
                        videoId: getIdFromURL('https://www.youtube.com/watch?list=SRDona%20aranha&v=MuBgIfBR1kA'),
                        src: '',
                        bundle: 'F_INFANTIL',
                        title: '',
                        segment: 'S_MATERNAL2',
                        discipline: '',
                        description: '<p>Dona Aranha </p><p><b>Infantil 3 – Caderno 1</b></p>',
                        toolTip: '',
                        isbn: 'Cheguei…e vou cantar',
                    }, {
                        linkReaOnly: 'https://www.youtube.com/watch?v=W_X0R5BP_g0',
                        LinkFree: '',
                        videoId: getIdFromURL('https://www.youtube.com/watch?v=W_X0R5BP_g0'),
                        src: '',
                        bundle: 'F_INFANTIL',
                        title: '',
                        segment: 'S_MATERNAL2',
                        discipline: '',
                        description: '<p>Pintinho amarelinho </p><p><b>Infantil 3 – Caderno 1</b></p>',
                        toolTip: '',
                        isbn: 'Gostei de cantar, quero mais!',
                    }, {
                        linkReaOnly: 'https://www.youtube.com/watch?v=nW6gvjifd14',
                        LinkFree: '',
                        videoId: getIdFromURL('https://www.youtube.com/watch?v=nW6gvjifd14'),
                        src: '',
                        bundle: 'F_INFANTIL',
                        title: '',
                        segment: 'S_MATERNAL2',
                        discipline: '',
                        description: '<p>Vamos passear na floresta</p><p><b>Infantil 3 – Caderno 1</b></p>',
                        toolTip: '',
                        isbn: 'Quer aprender como se brinca?',
                    }, {
                        linkReaOnly: 'https://www.youtube.com/watch?list=SRO%20sapo%20n%C3%A3o%20lava%20o%20p%C3%A9&v=0JkSpPZJDkE',
                        LinkFree: '',
                        videoId: getIdFromURL(
                            'https://www.youtube.com/watch?list=SRO%20sapo%20n%C3%A3o%20lava%20o%20p%C3%A9&v=0JkSpPZJDkE'
                        ),
                        src: '',
                        bundle: 'F_INFANTIL',
                        title: '',
                        segment: 'S_MATERNAL2',
                        discipline: '',
                        description: '<p>O sapo não lava o pé</p><p><b>Infantil 3 – Caderno 1</b></p>',
                        toolTip: '',
                        isbn: 'Cantando…',
                    }, {
                        linkReaOnly: 'https://www.youtube.com/watch?v=v0rX7souIRI',
                        LinkFree: '',
                        videoId: getIdFromURL('https://www.youtube.com/watch?v=v0rX7souIRI'),
                        src: '',
                        bundle: 'F_INFANTIL',
                        title: '',
                        segment: 'S_MATERNAL2',
                        discipline: '',
                        description: '<p>Para mamãe</p><p><b>Infantil 3 – Caderno 1</b></p>',
                        toolTip: '',
                        isbn: 'Cantando para mamãe',
                    },],
                    caderno2: [{
                        linkReaOnly: 'https://www.youtube.com/watch?v=3r4cadv1Cmw',
                        LinkFree: '',
                        videoId: getIdFromURL('https://www.youtube.com/watch?v=3r4cadv1Cmw'),
                        src: '',
                        bundle: 'F_INFANTIL',
                        title: '',
                        segment: 'S_MATERNAL2',
                        discipline: '',
                        description: '<p>Seu Lobato</p><p><b>Infantil 3 – Caderno 2</b></p>',
                        toolTip: '',
                        isbn: 'Cantando a música que tem os sons dos animais',
                    }, {
                        linkReaOnly: 'https://www.youtube.com/watch?v=YYz0tGoSz-4&list=PLBNloBgDpv0sMG5U3JdSbpfPVohEjw2YK',
                        LinkFree: '',
                        videoId: getIdFromURL('https://www.youtube.com/watch?v=YYz0tGoSz-4&list=PLBNloBgDpv0sMG5U3JdSbpfPVohEjw2YK'),
                        src: '',
                        bundle: 'F_INFANTIL',
                        title: '',
                        segment: 'S_MATERNAL2',
                        discipline: '',
                        description: '<p>Amigo sol</p><p><b>Infantil 3 – Caderno 2</b></p>',
                        toolTip: '',
                        isbn: 'Cantando uma música que fala sobre o sol',
                    },

                    ],
                    sugestao: [{
                        linkReaOnly: '',
                        LinkFree: '',
                        videoId: '',
                        link: 'http://www.letras.com.br/musicas-infantis',
                        src: 'https://app-sistemacpv.s3.amazonaws.com/thumbsViewer/tbw_sugestao_I.png',
                        bundle: 'F_INFANTIL',
                        title: 'Infantil 2 - Sugestões',
                        segment: 'S_MATERNAL1',
                        discipline: '',
                        description: '<p>Confira também outras sugestões</p><p>Caderno 2</p>',
                        toolTip: '',
                        isbn: 'Sugestões',
                    }]
                }
            },

            isCadernoICollapsed: true,
            isCadernoIICollapsed: false,
        };
    },
    computed: {
        permissions() {
            return this.$store.state.auth.userpermissions.permissions;
        },
        error503() {
            return (window.location.href = '/nao-autorizado');
        },
    },
    created() {
        this.$emit('update-header', {
            title: this.pageTitle,
            subtitle: this.pageSubtitle
        });
    },

    methods: {
        temPermissao(permissao) {
            return this.permissions.includes(permissao);
        },
        isToggleCadernoI() {
            this.isCadernoICollapsed = !this.isCadernoICollapsed
            this.isCadernoIICollapsed = false;
        },
        isToggleCadernoII() {
            this.isCadernoIICollapsed = !this.isCadernoIICollapsed
            this.isCadernoICollapsed = false;
        }
    }
};
</script>

<style lang="scss" scoped>
.main {
    margin-top: 30px;
}

.card_sistemacpv {
    border-radius: 8px;
    color: #3A1C53;
}

.btn_sistemacpv {
    display: inline-flex;
    min-width: auto;
    min-height: auto;

    margin: 20px auto 0;
    padding: 8px 16px;

    gap: 6px;

    background-color: #e98b24;
    border: 1px solid #e98b24;
    border-radius: 5px;

    display: flex;
    align-items: center;

    font-size: 16px;
    line-height: 22px;

    color: #fdf3e9;

    .icon {
        width: 18px;
        height: 18px;

        display: flex;
        align-items: center;

        i {
            font-size: 16px;
            line-height: 22px;
        }
    }

    &:hover {
        background-color: #d27d20;
        transition: all 0.3s ease-in-out;
        border: 1px solid #d27d20;
        color: #fdf3e9;
    }
}
</style>
